export enum FaultType {
  notStarting,
  puncture,
  battery,
  keys,
  gas,
  other,
}

export enum RedBatteryLight {
  no,
  yes,
  unknown,
}

export enum DestinationSelection {
  now,
  later,
}

export type VehicleFaultAssitance = {
  delayed: boolean | undefined;
  date?: Date | string;
  faultType: FaultType;
  notStartingReason: number | undefined;
  tyreChange: boolean | undefined;
  affectedTyres: number;
  faultInformation?: string;
  otherFaultInformation?: string;
  redBatteryLight?: RedBatteryLight | null;
  adults: number;
  minors: number;
  passengersWithSpecialNeeds: boolean | undefined;
  passengersInformation?: string;
  blockedTyres: boolean | undefined;
  outOfHighway: boolean | undefined;
  craneCode?: string;
  generateMediaTask: boolean | undefined;
};

export type BasicLocation = {
  latitude: number;
  longitude: number;
  locationInformation?: string;
};

export type LocationAssitance = BasicLocation & {
  externalRoad: boolean | undefined;
  undergroundParking: boolean | undefined;
};

export interface IAssistance extends LocationAssitance, VehicleFaultAssitance {
  policyCode: string;
  name: string;
  surname: string;
  dni?: string;
  plate?: string;
}

export interface IAssistanceResponse {
  codigo: string;
  descripcion: string;
  expediente: string;
  intervencion: string;
  codigoColaborador: string;
  colaborador: string;
}

export type AssistanceInformation = {
  file: string;
  identifier: string;
  intervention: string;
  provider: string;
  providerName: string;
};

export interface IPostponedSurvey {
  file: string;
  intervention: string;
  identifier: string;
}

export interface IGeolocation {
  latitude: string;
  longitude: string;
  externalRoad: boolean | undefined;
  undergroundParking: boolean | undefined;
}

export interface ISavePosition {
  identifier: string;
  file: string;
  position: IGeolocation;
}
